import { SimpleGrid } from "@chakra-ui/react";
import TradingGroupCard from "./TradingGroupCard";

function TradingGroupList({ groups, accountType, searchText, categoryText, isSearch, isCategory }) {
  

  // useEffect(() => {
  //   setGroupList(groups)
  // }, [groups]);

  return (
    <SimpleGrid minChildWidth="160px" spacing="30px" spacingY={"60px"}>
      {groups?.map((group, index) => {
        return (
          <TradingGroupCard
            key={index}
            group={group}
            accountType={accountType}
            searchText={searchText}
            categoryText={categoryText}
            isSearch={isSearch}
            isCategory={isCategory}
          />
        );
      })}
    </SimpleGrid>
  );
}

export default TradingGroupList;
